/**
 * CombineGems use case: merge two gems in the inventory.
 */

import { combineGems as domainCombineGems } from "../../domain/session.js";
import type { CombineGemError } from "../../domain/types.js";
import type { RenderPort } from "../ports.js";
import { sessionToView } from "../state-view.js";

export interface CombineGemsDeps {
  render: RenderPort;
  getSession(): import("../../domain/session.js").GameSession | null;
}

export function createCombineGems(deps: CombineGemsDeps) {
  return function combineGems(
    gemAId: string,
    gemBId: string,
  ): { ok: true; resultGemId: string } | CombineGemError {
    const session = deps.getSession();
    if (!session) return { code: "NotFound" };

    const result = domainCombineGems(session, gemAId, gemBId);
    if ("code" in result) return result;

    deps.render.update(sessionToView(session, "game"));
    return { ok: true, resultGemId: result.id };
  };
}
